var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g({staticClass:"iconfont",class:`icon-${_vm.name}`},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }